export * from "./document-page";
